import { maybe } from "@saleor/misc";
import { useTableStyles } from "@saleor/remittanceRunner/styles/tableStyles";
import { RemittanceStatusEnum } from "@saleor/types/globalTypes";
import React from "react";

import RemittanceRunnerStatusBadge from "../RemittanceRunnerStatusBadge";

interface RemittanceRunnerTblColStatusProp {
  status: RemittanceStatusEnum;
}

export const RemittanceRunnerTblColStatus: React.FC<RemittanceRunnerTblColStatusProp> = props => {
  const { status } = props;
  const tblClasses = useTableStyles(props);

  return (
    <div className={tblClasses.dataGroup}>
      <div className={tblClasses.dataTitle}>Status</div>
      <div className={tblClasses.dataDisplay}>
        {maybe(() => status) ? (
          <RemittanceRunnerStatusBadge status={status} />
        ) : (
          <span>-----</span>
        )}
      </div>
    </div>
  );
};

export default RemittanceRunnerTblColStatus;
